import { render, staticRenderFns } from "./QuickNav.vue?vue&type=template&id=ed90e83a&scoped=true&"
import script from "./QuickNav.vue?vue&type=script&lang=ts&"
export * from "./QuickNav.vue?vue&type=script&lang=ts&"
import style0 from "./QuickNav.vue?vue&type=style&index=0&id=ed90e83a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed90e83a",
  null
  
)

export default component.exports